module.exports = __webpack_public_path__ + "img/background043.80167d74.jpg";